
import Vue from "vue"
import { mapActions, mapGetters } from "vuex"

export default Vue.extend({
  data: () => ({
    loading: false,
  }),

  computed: {
    ...mapGetters("user", { accDeletion: "accountDeletion" }),

    accountMerging (): boolean {
      const data = this.accDeletion
      return data?.deleteReason === "OTHER_ACCOUNT" && data?.secondUser
    },

    title (): string {
      if (!this.accDeletion)
        return ""
      return this.$t(`pages.user.remove.lock.${this.accountMerging ? "union" : "deletion"}.title`) as string
    },

    text (): string {
      if (!this.accDeletion)
        return ""
      return this.$t(`pages.user.remove.lock.${this.accountMerging ? "union" : "deletion"}.text`, { date: this.date }) as string
    },

    date (): string {
      if (!this.accDeletion || !this.accDeletion.creationTime)
        return "--.--.--"
      return new Intl.DateTimeFormat(this.$i18n.locale, {
        dateStyle: "short",
        timeZone: "UTC",
      }).format(new Date(this.accDeletion.creationTime))
    },
  },

  methods: {
    ...mapActions("user", {
      logout: "LOGOUT",
      setAccDeletion: "SET_ACCOUNT_DELETION",
    }),

    async onCancel () {
      this.loading = true
      const [res, err] = await this.$api.user
        .revokeUserDeleteRequest()

      if (err || !res) {
        console.error(err || this.$t("unknownError"))
        this.loading = false
        return
      }

      this.loading = false
      this.setAccDeletion(null)
    },
  },
})
